<template lang="html">
	<div class="">
		<div v-if="errorShow">
			<HeadModule :openTarget="'news/detail?id=' + aid" />
			<div class="content">
				<!-- 资讯内容 -->
				<div class="invitation_content">
					<p class="invitation_title">{{information.title}}</p>
					<div class="invitation_head">
						<p> <span>发布者 : </span> {{information.username}} </p>
						<p class="issue_time">{{this.timestampToTime(2, information.dateline*1000)}}</p>
					</div>
					<div class="article" v-bind:class="{'showAll':show}">
						<div class="articleCon" ref="getheight" v-html="information.content"></div>
					</div>
					<div class="read_the_full_article_btn" v-show="article_btn" @click="show_all_txt_btn()">
						<span>阅读全文</span>
						<img src="../assets/image/all_txt.png" alt="">
					</div>
				</div>

				<!-- 今日热榜 -->
				<div class="hot_content">
					<h3>今日热榜</h3>
					<div class="hot_content_">
						<div class="">
							<div class="microVideo_mod" v-for="(aa, index) in information_hot" :key="index">
								<div class="" v-if="index == 0">
									<img src="../assets/image/huo_1.png" alt="">
								</div>
								<div class="" v-if="index == 1">
									<img src="../assets/image/huo_2.png" alt="">
								</div>
								<div class="" v-if="index == 2">
									<img src="../assets/image/huo_3.png" alt="">
								</div>
								<div class="" v-if="index == 3">
									<img src="../assets/image/huo_4.png" alt="">
								</div>
								<div class="" v-if="index == 4">
									<img src="../assets/image/huo_4.png" alt="">
								</div>
								<div class="microVideo_mod_">
									{{aa.title}}
									<WxOpenTag :extinfo="'news/detail?id=' + aa.articleid"/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 直播课程 -->
				<div class="live_streaming_content">
					<h3>直播课程</h3>
					<div class="module_content" v-for="(b, index) in live_streaming.slice(0, 2)" :key="index">
						<div class="module">
							<img :src="b.pic" alt="">
							<div class="module_con">
								<p class="module_title">{{b.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="b.avatar" alt="">
										<span>{{b.username}}</span>
									</div>
									<p>{{ b.hitnum }}人浏览</p>
								</div>
							</div>
							<WxOpenTag :extinfo="'class/detail?id=' + b.id"/>
						</div>
					</div>
				</div>

				<!-- 巢影短视屏 -->
				<div class="micro_video_content">
					<h3>短视频</h3>
					<div class="module_content" v-for="(m, index) in microVideo" :key="index">
						<div class="module">
							<img :src="m.pic" alt="">
							<div class="module_con">
								<p class="module_title">{{m.title}}</p>
								<div class="module_teacher">
									<div class="module_teacher_header">
										<img :src="m.avatar" alt="">
										<span>{{m.username}}</span>
									</div>
									<p>{{ m.likenum }}人浏览</p>
								</div>
							</div>
						</div>
						<WxOpenTag :extinfo="'openclass/detail?id=' + m.courseid"/>
					</div>
				</div>

				<!-- 全部评论   -->
				<div class="comment_content" v-show="commentData.length > 0">
					<div class="comment_headline">
						<h3>全部评论</h3>
						<p class="sumUp_comment_num">({{commentData.length}}条)</p>
					</div>
					<div class="personage_comment_mod" v-for="(a, index) in commentData" :key="index">
						<div class="personage_comment">
							<div class="personage_head_left">
								<img :src="a.pic" alt="" class="personage_head_img">
								<p>{{a.username}}</p>
							</div>
						</div>
						<div class="personage_comment_con_txt">
							{{a.message}}
						</div>
					</div>
					<WxOpenTag :extinfo="'post/detail?locateCom=1&id=' + aid"/>
				</div>
			</div>

			<div class="callAppIcon" v-show="callApp">
				<img src="../assets/image/icon/ic_button.png" alt="">
				<WxOpenTag ref="wxopentag" :extinfo="'news/detail?id=' + aid" />
			</div>

			<div class="topIcon" v-show="topPost">
				<img src="../assets/image/icon/ic_top.png" alt="" @click="getTopBtn">
			</div>
		</div>

		<ErrorPage v-else/>
	</div>
</template>

<script>
	import HeadModule from '@/components/HeadModule'
	import WxOpenTag from '@/components/WxOpenTag'
  import WxShare from '@/utils/wxshare';
	import ErrorPage from '@/components/ErrorPage'

	export default {
		components: {
			HeadModule: HeadModule,
			WxOpenTag: WxOpenTag,
			ErrorPage: ErrorPage,
		},
		data() {
			return {
				aid: this.$route.query.articleid,
				// 资讯
				information: [],
				information_content: '',
				information_hot: [],

				show: false,
				article_btn: true,

				invitation_mod: [],
				uesr_comment: [],
				else_uesr_comment: [],

				microVideo: [],
				// 直播
				live_streaming: [],

				// 评论
				commentData: [],
				callApp: false,
        topPost: false,
				errorShow: true,
			}
		},
		mounted() {
      this.wxshare = new WxShare();
			this._information();
			window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.getTopPost);
		},
		methods: {
			// 时间戳转化
			timestampToTime(type, cjsj) {
				var date = new Date(cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				if (type == 1) {
					var M_ = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
					var D_ = date.getDate() + '日'
					return M_ + D_
				} else {
					var Y = date.getFullYear() + '-'
					var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
					var D = date.getDate() + ' '
					var h = date.getHours() + ':'
					var m = date.getMinutes() + ':'
					var s = date.getSeconds()
					return Y + M + D + h + m + s
				}
			},
			// 资讯
			_information() {
				this.$http({
					url: '/PortalArticle/articleContent',
					method: 'get',
					params: {
						articleid: this.aid,
						start: 0,
						limit: 5,
						sort: 0,
					},
				}).then(res => {
					if (res.code >= 0) {
						this.information = res.data;
						document.title = this.information.title
            
            this.wxshare.share({
              title: this.information.title,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.information.pic,
            })
            
						// 显示展开全文
						this.txt_height();
						this._information_hot();

						// 直播
						this._live_streaming();
						// 短视屏
						this.micro_video();

						// 评论
						this._information_comment();
					}

					if (res.code == '-700') {
						this.errorShow = false;
					}
				})
			},
			// 资讯热门
			_information_hot() {
				this.$http({
					url: '/PortalArticle/articleList',
					method: 'get',
					params: {
						catid: '-1',
						start: 0,
						limit: 5,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.information_hot = res.data;
					}
				})
			},
			// 资讯评论
			_information_comment() {
				this.$http({
					url: '/PortalArticle/articleComment',
					method: 'get',
					params: {
						articleid: this.aid,
						start: 0,
						limit: 5,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.commentData = res.data;
					}
				})
			},
			// 判断文章显示高度
			txt_height() {
				this.$nextTick(function() {
					let height = this.$refs.getheight.offsetHeight;
					if (height > 478) {
						this.show = false;
						this.article_btn = true;
					} else {
						this.show = true;
						this.article_btn = false;
					}
				})
			},
			// 阅读全文按钮
			show_all_txt_btn() {
				this.show = true;
				this.article_btn = false;
			},

			// 直播课程
			_live_streaming() {
				this.$http({
					url: '/edu/listCourse',
					method: 'get',
					params: {
						type: '3',
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.live_streaming = res.data;
					}
				})
			},
			// 巢影短视屏
			micro_video() {
				this.$http({
					url: '/edu/weishi',
					method: 'get',
					params: {
						page: 1,
						limit: 2,
					},
				}).then((res) => {
					if (res.code >= 0) {
						this.microVideo = res.data;
					}
				})
			},

			// 监听打开app按钮显示隐藏
			handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },

      getTopPost() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.topPost = true;
        } else {
          this.topPost = false;
        }
      },

      getTopBtn() {
				window.scroll(0, 0);
			},
		},
	}
</script>

<style lang="css" scoped>
	.content {
		box-sizing: border-box;
		background: #F7F8F8;
	}

	/* 资讯内容 */
	.invitation_content {
		box-sizing: border-box;
		padding: 0 15px;
		background-color: #fff;
		padding-bottom: 1rem;
	}

	.invitation_title {
		margin-top: 17px;
		font-size: 18px;
		color: #1D2023;
		font-weight: 600;
	}

	.invitation_head {
		color: #606972;
		font-size: 10px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.issue_time {
		color: #606972;
		font-size: 10px;
		margin-left: 8px;
		margin-top: 4px;
	}

	.article {
		margin-top: 20px;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		padding-top: 20px;
		height: 478px;
		overflow: hidden;
	}

	.showAll {
		height: 100%;
		overflow: inherit;
	}
	
	.articleCon >>> img {
		width: 100%;
	}

	.read_the_full_article_btn {
		width: 100%;
		height: 40px;
		background-color: red;
		background: linear-gradient(#ffffff, #f2f2f2);
		line-height: 40px;
		text-align: center;
		color: #F5A623;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.read_the_full_article_btn img {
		width: 18px;
		height: 18px;
	}

	/* 今日热榜 */
	.hot_content {
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	.hot_content_ {
		display: flex;
	}

	.hot_content_icon {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	.hot_content_icon div {
		height: 46px;
		display: flex;
		align-items: center;
	}

	.hot_content_icon img {
		width: 18px;
		height: 18px;
		margin-right: 10px;
	}

	.microVideo_mod {
		width: 100%;
		height: 45px;
		line-height: 45px;
		display: flex;
	}

	.microVideo_mod img {
		width: 18px;
		height: 18px;
		margin-right: 10px;
		margin-top: 13px;
	}

	.microVideo_mod_ {
		position: relative;
		width: 100%;
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	/* 直播课程、巢影短视频*/
	.live_streaming_content,
	.micro_video_content {
		box-sizing: border-box;
		padding: 15px;
		padding-bottom: 0;
		background-color: #fff;
		margin-top: 1rem;
	}
	
	.module_content{
		position: relative;
		border-bottom: .05rem solid rgba(0, 0, 0, 0.1);
	}

	.module {
		box-sizing: border-box;
		padding: 1.2rem 0;
		display: flex;
		justify-content: space-between;
		font-size: 1.2rem;
		color: #606972;
	}

	.module_content:nth-last-child(1) {
		border-bottom: none;
	}

	.module img {
		width: 13.1rem;
		height: 8rem;
		border-radius: 5px;
		object-fit: cover;
		border: .05rem solid #E5E6EB;
	}

	.module_con {
		width: 58%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.module_title {
		color: #1D2023;
		font-size: 16px;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}

	.module_teacher {
		display: flex;
		font-size: 12px;
		justify-content: space-between;
	}

	.module_teacher_header {
		display: flex;
		align-items: center;
	}

	.module_teacher_header img {
		width: 1.95rem;
		height: 1.95rem;
		border-radius: 50%;
		object-fit: cover;
		margin-right: .5rem;
		border: .05rem solid #E5E6EB;
	}

	.teacher_name {
		color: #606972;
	}

	.clod_app_btn {
		color: #2086FC;
		font-size: 12px;
	}

	/* 全部评论 */
	.comment_content {
		position: relative;
		padding: 15px;
		margin-top: 10px;
		background-color: #fff;
	}

	.comment_headline {
		display: flex;
		align-items: flex-end;
	}

	.sumUp_comment_num {
		margin-left: 5px;
		font-size: 11px;
		color: #606972;
	}

	.personage_comment_mod {
		box-sizing: border-box;
		padding: 15px 0;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
	}

	.personage_comment_mod:nth-last-child(2) {
		border-bottom: none;
	}

	.personage_comment {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.personage_head_left {
		display: flex;
		align-items: center;
	}

	.personage_head_img {
		width: 3.5rem;
		height: 3.5rem;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 1.1rem;
		border: .05rem solid #E5E6EB;
	}

	.personage_comment_con_txt {
		box-sizing: border-box;
		margin-left: 45px;
		margin-top: 5px;
	}

	/* 下载按钮 */
	.open_APP_btn {
		position: relative;
		margin: 10px 15px;
		border-radius: 3px;
		height: 35px;
		line-height: 35px;
		background-color: #E50120;
		text-align: center;
		color: #FCFCFC;
		font-size: 16px;
	}

	.callAppIcon {
    position: fixed;
    right: 0;
    bottom: 10.6rem;
    z-index: 10;
  }

  .callAppIcon img {
    width: 11.1rem;
    height: 3.35rem;
  }

  .topIcon {
		position: fixed;
		right: 1.1rem;
		bottom: 3rem;
		z-index: 11;
	}

	.topIcon img {
    width: auto;
    height: 4.15rem;
  }
</style>
